import axios from "axios";
import { RegisterPayload, RegisterResponse, VCatUserResponse, VCatUserUpdate } from "../../types/models";
import { updateUser, getUser, deleteUser, getDetailedUserInfo } from "../baseUserService";
import { VCatUserTransaction } from "../../types/models/vCatUserTransaction";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export const registerVcatUser = async (data: RegisterPayload): Promise<RegisterResponse> => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}/vcat-user/register`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("VCat Registration Error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.detail || error.message);
    } else {
      console.error("Generic Registration Error:", (error as Error).message);
      throw error;
    }
  }
};

export const fetchVcatUser = (userId: number) =>
  getUser<VCatUserResponse>("vcat-user", userId);

export const updateVcatUser = (userId: number, data: VCatUserUpdate) =>
  updateUser<VCatUserUpdate, VCatUserResponse>("vcat-user", userId, data);

export const deleteVcatUser = (userId: number, token: string) =>
  deleteUser("vcat-user", userId, token);

export const getDetailedVcatUserInfo = () => getDetailedUserInfo<VCatUserResponse>("vcat-user");

// export const getAllVcatUsers = () => getAllUsers<VCatUserResponse>("vcat-user");

export const getMyTransactions = async (): Promise<VCatUserTransaction[]> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  try {
    const response = await axios.get<VCatUserTransaction[]>(`${REACT_APP_API_URL}/transactions/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch transactions:", error);
    throw new Error("Failed to fetch your transactions.");
  }
};